import { lazy } from "react"
import FlagProtectedRoute from "~/router/outlets/FlagProtectedRoute"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const CountryPayrollFileDetailsPage = lazy(
  () => import("~/adminApp/pages/PayoutAutomationPage/CountryPayrollFileDetailsPage"),
)
const PayoutAutomationFailedReportPage = lazy(
  () => import("~/adminApp/pages/PayoutAutomationPage/PayoutAutomationFailedReportPage"),
)
const PayoutAutomationPage = lazy(
  () => import("~/adminApp/pages/PayoutAutomationPage/PayoutAutomationPage"),
)

export const staffPaymentRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      element: <FlagProtectedRoute flags={{ payPayoutAutomationAccess: true }} />,
      children: [
        {
          path: "country-payrolls",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <PayoutAutomationPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "country-payrolls/:strongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CountryPayrollFileDetailsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "country-payrolls/upload-failed/:strongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <PayoutAutomationFailedReportPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
  ],
  DeprecatedFullScreen: [],
}
